import axios from "axios";

let signOutFn = null;
let redirecting = false;

// react-auth-kit keeps the session in memory as well as in the cookie. Clearing
// the cookie by hand left that memory state intact, so /login sent the user
// straight back to the board, which asked again and got 401 again - a loop.
export function registerSignOut(fn) {
  signOutFn = fn;
}

export function installSessionGuard() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const unauthorized = error?.response?.status === 401;
      const onLogin = window.location.pathname.startsWith("/login");

      if (unauthorized && !onLogin && !redirecting) {
        redirecting = true;
        try {
          if (signOutFn) signOutFn();
        } catch (e) {
          /* sign out is best effort */
        }
        localStorage.clear();
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
  );
}
